import * as Yup from 'yup';

export const CreateDialogSchema = Yup.object().shape({
  recipient: Yup.object().required('Недопустимое значение'),
  topic: Yup.string().nullable().max(100, 'Максимум 100 символов'),
});
